import { Copy, Heart } from 'lucide-react';
import { toast } from 'sonner';
import { appConfig } from '@/config';
import { Button, Modal } from '@/components/ui';
import qrCodePix from '@/assets/images/qrCodePix.png';

export function DonationModal({ open, onClose }) {
  const { pixKey, pixKeyType, recipientName, message } = appConfig.donation;

  const onCopyPixKey = async () => {
    try {
      await navigator.clipboard.writeText(pixKey);
      toast.success('Chave PIX copiada');
    } catch {
      toast.error('Não foi possível copiar a chave PIX');
    }
  };

  return (
    <Modal open={open} onClose={onClose} title={`Apoie o ${appConfig.appName}`}>
      <div className="space-y-5">
        <p className="text-sm leading-relaxed text-[var(--muted-foreground)]">{message}</p>

        <div className="flex flex-col items-center gap-4 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--muted)]/40 p-5">
          <div className="rounded-lg bg-white p-3 shadow-sm">
            <img
              src={qrCodePix}
              alt="QR Code PIX para contribuição"
              className="h-[180px] w-[180px] object-contain"
            />
          </div>
          <div className="text-center">
            <p className="text-sm font-medium">{recipientName}</p>
            <p className="mt-1 text-xs text-[var(--muted-foreground)]">{pixKeyType}</p>
            <p className="mt-1 break-all font-mono text-sm">{pixKey}</p>
          </div>
        </div>

        <Button className="w-full" onClick={onCopyPixKey}>
          <Copy size={16} aria-hidden />
          Copiar chave PIX
        </Button>

        <p className="flex items-start gap-2 text-xs text-[var(--muted-foreground)]">
          <Heart size={14} className="mt-0.5 shrink-0 text-[var(--primary)]" aria-hidden />
          Contribuição totalmente voluntária e opcional. Escaneie o QR Code ou copie a chave PIX.
        </p>
      </div>
    </Modal>
  );
}
